module.exports = __webpack_public_path__ + "static/media/video.0b3344ce.mp4";